import { render, staticRenderFns } from "./limitCoins.vue?vue&type=template&id=6ed050b9&scoped=true&"
import script from "./limitCoins.vue?vue&type=script&lang=ts&"
export * from "./limitCoins.vue?vue&type=script&lang=ts&"
import style0 from "./limitCoins.scss?vue&type=style&index=0&id=6ed050b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed050b9",
  null
  
)

export default component.exports